export default __webpack_public_path__ + "static/media/dawn-to-dusk-logo.f63a6900.png";